<template>
	<b-card-body>
		<div class="row">
			<div class="col-12 col-md-10">
				<div class="form-group">
					<label>Name</label>
					<input type="text" class="form-control" v-model.lazy="name" />
				</div>
			</div>
			<div class="col-12 col-md-2">
				<div class="form-group">
					<label>Level</label>
					<input type="number" class="form-control" v-model.number="drone.Level" />
				</div>
			</div>
		</div>
		<hr />
		<div class="row">
			<div class="col-12 col-sm-3">
				<label>Chasis Info</label>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text stat-label">Type</span>
					</div>
					<input class="form-control" v-model.lazy="type">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text stat-label">Size</span>
					</div>
					<input class="form-control" v-model.lazy="size">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text stat-label">Speed</span>
					</div>
					<input class="form-control" v-model.lazy="speed">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text stat-label">EAC</span>
					</div>
					<input class="form-control" v-model.number.lazy="eac">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text stat-label">KAC</span>
					</div>
					<input class="form-control" v-model.number.lazy="kac">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text stat-label">Good Save</span>
					</div>
					<select class="form-control" v-model.lazy="save">
						<option>Fortitude</option>
						<option>Reflex</option>
						<option>Will</option>
					</select>
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text stat-label">Skills</span>
					</div>
					<input class="form-control" v-model.lazy="skills">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text stat-label">Initial Mods</span>
					</div>
					<input class="form-control" type="number" v-model.number.lazy="initial">
				</div>
			</div>
			<div class="col-12 col-sm-3">
				<label>Ability Scores &amp; Increases</label>
				<div class="input-group" v-for="(increase, ability) in scores" :key="`drone-increases-${level}-${ability}`">
					<div class="input-group-prepend">
						<div class="input-group-text">
							<input type="checkbox" v-model.lazy="increases" :value="ability">
						</div>
						<span class="input-group-text" style="width: 3.5em;">{{ability|abbr}}</span>
					</div>
					<input type="number" class="form-control" v-model.lazy="scores[ability]" />
					<div class="input-group-append float-right">
						<span class="input-group-text" style="width: 3em;">{{abilityMod(scores[ability])}}</span>
					</div>
				</div>
			</div>
			<div class="col-12 col-sm-3">
				<label>Drone Mods</label>
				<ul class="list-unstyled">
					<li v-for="n in (parseInt(initial||0) + droneTable[dlevel].Mod)" :key="`drone-mods-${level}-${n}`"><input class="form-control" v-model.lazy="mods[n-1]" /></li>
				</ul>
			</div>
			<div class="col-12 col-sm-3">
				<label>Drone Feats</label>
				<ul class="list-unstyled">
					<li v-for="n in droneTable[dlevel].Feat" :key="`drone-feats-${level}-${n}`"><input class="form-control" v-model.lazy="feats[n-1]" /></li>
				</ul>
			</div>

		</div>

	</b-card-body>
</template>

<script>
function mapDroneProperties( properties ){
	var computed = {}
	properties.forEach(property => {
		computed[property] = {
			get () {
				return this.$store.getters[`character/drones/${property}`](this.level)
			},
			set ( value ){
				this.$store.dispatch(`character/drones/update${this.ucFirst(property)}`,{
					level: this.level,
					value,
				})
			}
		}
	})
	return computed
}

import ucFirst from "@/mixins/ucfirst.js";
export default {
	mixins: [
		ucFirst,
	],
	props: [
		'level',
	],
	methods: {
		abilityMod: function(score){
			return (score-10)/2
		}
	},
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		AbilityScores: function(){
			return this.$store.state.Character.AbilityScores.Base
		},
		droneTable: function(){
			return this.$store.state.drones.stats
		},
		drone: function() {
			return this.$store.state.Character.Levels[this.level].Drone
		},
		...mapDroneProperties([
			'name',
			'dlevel',
			'type',
			'size',
			'speed',
			'eac',
			'kac',
			'save',
			'skills',
			'initial',
			'scores',
			'increases',
			'mods',
			'feats',
		])
	}
	
}
</script>

<style scoped>
.stat-label {
	width: 6.5em;
}
</style>